// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fKE1C","outerWrapper":"styles_outerWrapper__oUfqV"};